import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroupDirective } from '@angular/forms';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { FileHandlerService, IFileOptions } from 'src/app/utility/services/file-handler/file-handler.service';
import { AdditonalDocumentSubmissionMessage } from 'src/app/utility/services/message/custom-messages';
import { ClaimTypePrefixNumber, ValidatorType } from 'src/app/utility/enum/global-enum';
import { IFileExtend } from '../../../model/IFileExtend';
import { FileValidatorService } from '../../../service/file-validator/file-validator.service';
import { GroupGlSubmissionService } from '../../../service/group-gl-submission/group-gl-submission.service';
import { BancaOnlineSubmissionService } from 'src/app/feature-module/investigation-queue/service/banca-online-submission/banca-online-submission.service';

@Component({
  selector: 'app-online-document-upload-banca-gl',
  templateUrl: './online-document-upload-banca-gl.component.html',
  styleUrls: ['./online-document-upload-banca-gl.component.scss']
})
export class OnlineDocumentUploadBancaGlComponent implements OnInit {

  //Common Variable
  customMessage = new AdditonalDocumentSubmissionMessage();
  isDocSubmission = true;
  fileExtends: IFileExtend[];
  fileExtend: IFileExtend;
  fileOption: IFileOptions = { acctptedTypes: "" };

  claimFormFile: any;
  //Additional Document Submission Variable
  claimEntryId: number;
  claimTypePrefix: string;
  claimInformation: any;
  bundleClaimId: number;

  //Online Group Claim Submission variable
  productId: number;
  enrolId: number;
  enrolDependentId: number;
  natureOfSickness: string;
  claimAmount: number;
  insuredName: string;
  productName: string;
  patientName: string;
  certificateNumber: string;
  groupPolicyNumber: string;
  groupPolicyName: string;
  ppoRequestId: number;
  //Input and Output decorator
  @Input() isAdditionDocumentSubmission: boolean;
  @Input() resetDocuments: boolean;

  @Input() set dataReqiredForAdditionalDocumentUpload(value) {
    if (value) {
      if (this.isAdditionDocumentSubmission && value.claimEntryId && value.claimTypePrefix) {
        this.claimEntryId = value.claimEntryId;
        this.claimTypePrefix = value.claimTypePrefix;
        this.patientName = value.patientName
        if(this.claimTypePrefix == ClaimTypePrefixNumber.BL || this.claimTypePrefix == ClaimTypePrefixNumber.BM)
           this.bundleClaimId = value.bundleClaimId;
        if(this.resetDocuments){
        this.isDocSubmission = true;
        this.getNIGODocuments();
        }
      }
      this.getFileExtension();
    }
  };

  @Input() set dataReqiredForClaimSubmissionDocumentUpload(value) {
  };
  @Output() onDocumentUploadedDone = new EventEmitter<any>();
  @Output() onBackButtonSubmission = new EventEmitter<any>();
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private fileHandlerService: FileHandlerService,
    private fileValidatorService: FileValidatorService,
    private groupGlSubmissionService: GroupGlSubmissionService,
    private bancaOnlineSubmissionService: BancaOnlineSubmissionService
  ) { }

  ngOnInit() {
  }

  getFileExtension() {
    this.fileValidatorService
      .getByValidatorType(ValidatorType.GroupClaimSubmission)
      .subscribe(
        res => {
          this.fileOption.validators = res;
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      );
  }

  getNIGODocuments() {
    this.fileExtends = [];

    if(this.claimTypePrefix == ClaimTypePrefixNumber.GL){
      this.groupGlSubmissionService
      .getGlRequireNigoDocuments(this.claimEntryId)
      .subscribe(
        res => {
          if(res) {
            res.forEach(item => {
              this.fileExtends.push({
                documentId: item.documentTypeId,
                docName: item.documentName,
                file: null,
                acctptedTypes: "",
                index: 1,
                isOptional: item.isOptional
              });
            });

            this.documentRequiredValidation();
          }

        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      );
    }
    else if(this.claimTypePrefix == ClaimTypePrefixNumber.BL || this.claimTypePrefix == ClaimTypePrefixNumber.BM){
      this.bancaOnlineSubmissionService
      .getBancaRequireNigoDocuments(this.bundleClaimId)
      .subscribe(
        res => {
          if(res) {
            res.forEach(item => {
              this.fileExtends.push({
                documentId: item.documentTypeId,
                docName: item.documentName,
                file: null,
                acctptedTypes: "",
                index: 1,
                isOptional: item.isOptional
              });
            });

            this.documentRequiredValidation();
          }
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      );
    }


  }

  onFileChange(event, item: IFileExtend) {
    if (
      event &&
      this.fileHandlerService.validator(event.target.files[0], this.fileOption)
    ) {
      item.file = event.target.files[0];
      this.documentRequiredValidation();
    }
  }

  documentRequiredValidation() {
    //As All documents are mandatory. So check the number of required document and number of uploaded documents
    let rerquiredfile = 0;
    this.fileExtends.forEach(ele => {
      if (!ele.isOptional) {
        rerquiredfile++;
      }
    });
    let uploadedFile = 0;
    this.fileExtends.forEach(x => {
      if (x.file != null && !x.isOptional) {
        uploadedFile++;
      }
    });

    if (rerquiredfile === uploadedFile) {
      this.isDocSubmission = false;
    } else {
      this.isDocSubmission = true;
    }
  }

  addDocument(item: IFileExtend) {
    let indx = 0;
    const obj = this.fileExtends.filter(x => x.documentId === item.documentId);
    obj.forEach(element => {
      if (element.index > indx) {
        indx = element.index;
      }
    });

    this.fileExtends.push({
      documentId: item.documentId,
      docName: item.docName,
      file: null,
      acctptedTypes: "",
      index: indx + 1,
      isOptional: item.isOptional
    });

    this.fileExtends = this.fileExtends.sort((t1, t2) => {
      if (t1.documentId > t2.documentId) {
        return 1;
      }
      if (t1.documentId < t2.documentId) {
        return -1;
      }
      return 0;
    });
    this.documentRequiredValidation();
  }

  removeDocument(item: IFileExtend) {
    this.fileExtends = this.fileExtends.filter(x => x !== item);
    this.documentRequiredValidation();
  }

  getAdditionalDocumentData() {
    let entity = {
      claimEntryId: this.claimEntryId,
      componentValidatorId: ValidatorType.GroupClaimSubmission,
      ppoRequestId: this.ppoRequestId,
    }
    const formData = this.getFormData(entity);
    return formData;
  }

  getFormData(data: any): FormData {
    let tempFileExtends = [...this.fileExtends];

    const formData = new FormData();
    formData.append("model", JSON.stringify(data));
    let additionalId: number = 0;
    tempFileExtends.forEach(x => {
      if (x.index != 0) {
        if (tempFileExtends.filter(f => f.documentId == x.documentId).length > 1)
          additionalId++;
      }
      formData.append(
        x.documentId.toString() + "-" + additionalId.toString(),
        x.file
      )
    });
    return formData;
  }

  submit() {
    if (this.isAdditionDocumentSubmission) {
      this.submitAdditionalDocuments();
    }
  }

  submitAdditionalDocuments() {
    const data = this.getAdditionalDocumentData();

    if (this.claimTypePrefix == ClaimTypePrefixNumber.BL || this.claimTypePrefix == ClaimTypePrefixNumber.BM) {
      this.bancaOnlineSubmissionService
        .additionalDocumentSubmission(data)
        .subscribe(
          (res) => {
            this.resetFormSetting();
            // ** Notify Parent
            this.notifyParentComponent();
            this.messageService.show(
              this.customMessage.additionalSubmissionCommonMessage,
              "success"
            );
          },
          (err) => {
            this.messageService.show(err.error.message, "error");
          }
        );
    } else if (this.claimTypePrefix == ClaimTypePrefixNumber.GL) {
      this.groupGlSubmissionService
        .additionalDocumentSubmission(data)
        .subscribe(
          (res) => {
            this.resetFormSetting();
            // ** Notify Parent
            this.notifyParentComponent();
            this.messageService.show(
              this.customMessage.additionalSubmissionCommonMessage,
              "success"
            );
          },
          (err) => {
            this.messageService.show(err.error.message, "error");
          }
        );
    }
  }

  resetFormSetting() {
    this.fileExtends = [];
    this.fileExtend = null;
    this.isDocSubmission = true;
  }

  notifyParentComponent() {
    const data = {
      isDocumentUploaded: true
    }
    this.onDocumentUploadedDone.emit(data);
  }

  viewDocument(file) {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }

  clearUpload(item) {
    item.file = null;
    this.documentRequiredValidation();
  }

  onBackButtonClick() {
    this.onBackButtonSubmission.emit();
  }
}
